// extracted by mini-css-extract-plugin
module.exports = {"rightPanel":"AppLayout_rightPanel__39WCl","content":"AppLayout_content__1hwOx"};